import { Fragment } from 'react';

const Emails = ({ customer }) => {
  if (!customer.emails) {
    return null;
  }
  return customer.emails.map((email) => (
    <Fragment key={email.id}>
      {email.email}
      <br />
    </Fragment>
  ));
};

export default Emails;
